exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/classmates.js-WebpackMultiOutput";